define([
    'jquery',
    'pageLoader',
    'popup',
    'globalVars',
    'mainGtm',
    'weborama',
    'mage/translate',
    'mage/validation',
], ($, pageLoader, popup, { $body }, mainGtm, weborama, $t) => {
    return {
        settings: {
            $newsletterPopup: $('#popupSubscribe'),
            $form: $('#subscribeForm'),
            options: {
                title: '',
                modalClass: 'popup-subscribe-modal',
                frameName: '#popupSubscribe',
            },
            source: '',
        },

        init(source) {
            this.loadImage();
            this.validateForm();

            this.gtmSource = source;
            this.settings.source = source;
        },

        loadImage() {
            const $el = $('#subscribe').find('.js-lazy');

            $el.attr('src', $el.data('lazy-src')).removeClass('js-lazy');
        },

        validateForm() {
            const { $form } = this.settings;

            $form.mage('validation', {
                errorClass: 'mage-error',
                submitHandler: () => {
                    this.sendFormData($form);
                },
            });
        },

        sendFormData($form) {
            $.ajax({
                type: 'post',
                contentType: 'application/json',
                url: $form.attr('action'),
                data: JSON.stringify({
                    candidate: {
                        email: $form.find('[name="email"]').val(),
                        point_of_contact: this.settings.source,
                    },
                }),
                beforeSend() {
                    pageLoader.showLoading();
                },
                complete() {
                    pageLoader.hideLoading();
                    $form.addClass('_send');
                },
                error() {
                    this.showResponse({
                        status: 'error',
                        message: $t(
                            'An error occurred on the server. Please try to place the order again'
                        ),
                    });
                },
                success: data => {
                    if (data === true) {
                        this.showResponse({
                            status: 'success',
                            message: $t('We have saved your subscription.'),
                        });
                        weborama.pushSubscription(
                            'email',
                            $form.find('[name="email"]').val()
                        );
                        mainGtm.pushSubscription(this.gtmSource);
                    }
                },
            });
        },

        showResponse({ status, message }) {
            if (status && status === 'success') {
                $('.js-subscribe-content-inner').hide();
                $('.js-answer-subscribe-message').text(message).show();

                setTimeout(() => {
                    $('#subscribe').fadeOut();
                }, 1000);
            } else {
                message &&
                    $('.js-answer-subscribe-error-message').text(message);
                popup(this.settings.options);
            }
        },
    };
});
